import * as ProgressPrimitive from '@radix-ui/react-progress';
import cx from 'classnames';

interface ProgressIndicatorProps {
  currentProgress: number;
  variant: 'post' | 'reward' | 'signup-flow';
}

const ProgressIndicator = ({ currentProgress = 60, variant = 'post' }: ProgressIndicatorProps) => {
  const classNames =
    variant === 'reward'
      ? 'border border-gray-200 relative overflow-hidden rounded-full w-full h-4'
      : 'relative overflow-hidden h-1.5 bg-transparent w-full';

  return (
    <ProgressPrimitive.Root className={classNames} value={currentProgress}>
      <ProgressPrimitive.Indicator
        className={cx('h-full w-full bg-wt-primary', variant === 'signup-flow' && 'transition-all')}
        style={{ width: `${currentProgress}%` }}
      />
    </ProgressPrimitive.Root>
  );
};

export default ProgressIndicator;
